var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 14990",
    transform: "translate(15 49)",
    fill: "#3b5175",
    stroke: "#707070",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1057",
    transform: "translate(-15 -49)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 14991",
    fill: "none",
    d: "M15 49h24v24H15z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    fill: "#3b5175"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20428",
    d: "M36 71H18a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20429",
    d: "m21.3 61.75 5 4.95a.95.95 0 0 0 1.4 0l5-4.95a1.05 1.05 0 0 0 .1-1.35.95.95 0 0 0-1.5-.1L28 63.6V52a1 1 0 0 0-2 0v11.6l-3.3-3.3a.95.95 0 0 0-1.5.1 1.05 1.05 0 0 0 .1 1.35Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon1);
export default __webpack_public_path__ + "static/media/Download_Icon1.9ccd364963d5fc6b798d52823d0bdd6e.svg";
export { ForwardRef as ReactComponent };